import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'

class LabelsModule extends PureComponent {

  static propTypes = {
    dbPath: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      items: []
    }
  }

  componentDidMount() {
    firebase.database()
      .ref(this.props.dbPath)
      .on('value', this.onUpdate)
  }

  componentWillUnmount() {
    firebase.database()
      .ref(this.props.dbPath)
      .off('value', this.onUpdate)
  }

  onUpdate = (snapshot) => {
    let value = snapshot.val()
    // Get list of tasks
    const list = value && value.list || {}
    this.setState({ items: Object.keys(list) })
  }

  render() {
    return (
      <span
        style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.4)'}}>
        {
          this.state.items.length > 0
            ? `${this.state.items.join(', ')}`
            : `${this.props.labelName} list is empty`
        }
      </span>
    )
  }
}

export const AssistantsModule = ({
  ...props
}) => (
  <LabelsModule
    labelName={'Assistants'}
    {...props}/>
)

export const LaborersModule = ({
  ...props
}) => (
  <LabelsModule
    labelName={'Laborers'}
    {...props}/>
)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/text/LabelsModule.js